import React from 'react';
import RichText from '../../atoms/rich-text/rich-text';
import IRichText from '../../../models/viewModels/base/IRichText';

type Props = {
  title?: string;
  text: IRichText;
  titleSize?: number;
  children?: any;
  id?: any;
};

export default function TextBlock({ title, text, titleSize = 2, id }: Props) {
  const TitleTag = `h${titleSize}` as keyof JSX.IntrinsicElements;
  return (
    <div className='text-block' id={id}>
      {title && <TitleTag>{title}</TitleTag>}
      <RichText richText={text} />
    </div>
  );
}
